/**
 * Builds an authentication URL with source and destination parameters
 * @param {string} authPath - The auth path (e.g., '/signup' or '/login')
 * @param {string} source - The source identifier (e.g., 'nav', 'hero', etc.)
 * @param {string|null} urlPrefix - Optional URL prefix (e.g., 'fr', 'es')
* @returns {string} The complete URL with query parameters
 */
const buildAuthUrl = (authPath, source, urlPrefix = undefined) => {
  // Return early on server-side (no location object)
  if (typeof window === "undefined" || typeof location === "undefined") {
    return;
  }
  
  // Use the current path as a dest param so that after login/signup, user can be redirected back to where they were. We also check to make sure the path is valid and not just "/" before adding it as a param
  const currentPath = location.pathname + location.search;

  const params = new URLSearchParams();
  params.set("source", source);


  if (currentPath && currentPath !== "/" && currentPath.startsWith('/') && !currentPath.startsWith('//'))  {
    params.set("dest", currentPath); // URLSearchParams handles encoding automatically
  }

  const prefixPath = urlPrefix ? `/${urlPrefix}` : '';


  return `${prefixPath}${authPath}?${params.toString()}`;
};

const signinUrlFromNav = (urlPrefix = undefined) => buildAuthUrl('/signin', 'log', urlPrefix)

const signupUrlFromNav = (urlPrefix = undefined) => buildAuthUrl('/signup', 'nav', urlPrefix)

export { buildAuthUrl, signinUrlFromNav, signupUrlFromNav };
